import { useCallback } from "react";
import { Field, useFormikContext } from "formik";
import { Autocomplete } from "../components";
import { useFormInputHelpers } from "./useFormInputHelpers";

const FormAutocomplete = ({
  className,
  helperText,
  id,
  name,
  shouldHaveErrorBehaviorAfterSubmit,
  isMultiple,
  onChange,
  ...props
}) => {
  const { setFieldValue, setFieldTouched } = useFormikContext();
  const { shouldDisplayError, finalHelperText } = useFormInputHelpers({
    name,
    shouldHaveErrorBehaviorAfterSubmit,
    helperText,
  });

  const handleChange = useCallback(
    (newVal) => {
      if (typeof onChange === "function") {
        onChange(newVal);
        return;
      }

      setFieldValue(name, newVal).then(() => {
        setFieldTouched(name, true);
      });
    },
    [name, setFieldValue, setFieldTouched, onChange]
  );

  return (
    <Field
      as={Autocomplete}
      id={id || name}
      name={name}
      isMultiple={isMultiple}
      isError={shouldDisplayError}
      helperText={finalHelperText}
      className={className}
      onChange={handleChange}
      {...props}
    />
  );
};

export default FormAutocomplete;
